export const getGsaPerDiem = async (city, state, year) => {
    return fetch(`https://api.gsa.gov/travel/perdiem/v2/rates/city/${city}/state/${state}/year/${year}?api_key=${process.env.REACT_APP_GSA_API_KEY}`)
        .then((response) => response.text())
        .then((body) => {
            return JSON.parse(body);
        });
};

export const getNationalGsaLodgingPerDiem = async () => {
    const today = new Date();
    const year = today.getFullYear();

    return fetch(`https://api.gsa.gov/travel/perdiem/v2/rates/conus/lodging/${year}?api_key=${process.env.REACT_APP_GSA_API_KEY}`)
        .then((response) => response.text())
        .then((body) => {
            return parseFloat(JSON.parse(body)[0]['Jan']);
        });
};

export const getNationalGsaMealPerDiem = async () => {
    const today = new Date();
    const year = today.getFullYear();

    return fetch(`https://api.gsa.gov/travel/perdiem/v2/rates/conus/mie/${year}?api_key=${process.env.REACT_APP_GSA_API_KEY}`)
        .then((response) => response.text())
        .then((body) => {
            return parseFloat(JSON.parse(body)[0]['total']);
        });
};